export const DELIVERY_SERVICE_LISTING = 'DELIVERY_SERVICE_LISTING'
export const DELIVERY_CATEGORY = 'DELIVERY_CATEGORY'
export const DELIVERY_SINGLE = 'DELIVERY_SINGLE'
export const DELIVERY_LOCATIONS = 'DELIVERY_LOCATIONS'
export const CLEAR_DATA = 'CLEAR_DATA'
